import React from 'react';
import '../../../styles/mobile/About.scss';
import CmykFullMobile from "../../../common_components/design_components/CmykFullMobile";


const AboutMobile = () => {
  return (
    <div className="about-container">
      <header className="about-header">
        <CmykFullMobile />
        <h1>ABOUT</h1>
      </header>
      <div className="about-content">
        <p>
          Hi, I’m Jacob—a web developer, graphic designer, and practicing artist with a passion for creativity and problem-solving. Over the years, I’ve combined technical expertise with artistic vision to craft solutions that look great and work even better. Whether I’m coding a responsive web application, designing an engaging user experience, or painting in my studio, I thrive on ideation and bringing fresh ideas to life.
        </p>
        <p>
          I approach every project with an open mind because no two challenges are the same. Each project deserves a tailored solution, informed by its unique goals, merits, and obstacles. Staying up to date on the latest technology trends and tools helps me deliver thoughtful, cutting-edge results.
        </p>
        <p>
          Beyond the professional realm, I’m an art enthusiast with a love for painting, reading, and music. Art and art history are core passions of mine, and they often inspire my work. I also deeply value human connection—listening to others, understanding their ideas, and empathizing with their needs is as important to me as the work itself.
        </p>
        <p>
          If you’re looking for someone who combines creativity, technical skill, and a people-first approach, I’d love to collaborate with you. Let’s create something amazing together!
        </p>
      </div>
    </div>
  );
};

export default AboutMobile;
